import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../../store";

export interface FormSubmissionState {
  isSubmitting: boolean;
}

export const selectFormSubmission = createSelector(
  (state: RootState) => state.formSubmission,
  (formSubmission) => formSubmission.isSubmitting,
);

export const formSubmissionSlice = createSlice({
  name: "formSubmission",
  initialState: { isSubmitting: false } as FormSubmissionState,
  reducers: {
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload;
    },
  },
});

export const { setFormSubmitting } = formSubmissionSlice.actions;
